<!-- 节目管理弹窗 -->
<template>
  <div class="card-info-box">
    <!-- <p class="close" @click="closeHandle">X</p> -->
    <el-card :body-style="{ padding: '0px' }">
      <Video :imgUrl="dialogData.data.video.videoImgPaths && dialogData.data.video.videoImgPaths[0].imgPath"
             :isProgram="isProgram"
             :videoPath="dialogData.data.video && dialogData.data.video.videoPath"/>
      <div class="tab-content">
        <el-button v-if="dialogData.project == 'vod' && dialogData.isShowEdit" type="primary" class="edit-btn" plain @click="goEdit(dialogData.data)">编辑</el-button>
        <el-tabs class="tab-list" v-model="currentTabComponent">
          <el-tab-pane label="编目信息" name="ItemInfo" />
          <el-tab-pane label="文件信息" name="TabFileInfo" />
          <el-tab-pane v-if="dialogData.project=='vod'" label="状态" name="TabStateInfo" />
        </el-tabs>
        <div class="main">
          <component v-bind:is="currentTabComponent" :dialogData="dialogData.data" :project="dialogData.project"
            @goRelease="goRelease"
            @refresh="refresh">
          </component>
        </div>
      </div>
    </el-card>
    <releaseStatusDialog ref="releaseStatusDataDialog" :releaseStatusData="releaseStatusData"></releaseStatusDialog>
  </div>
</template>
<script>
import Video from '@/components/Video'
import ItemInfo from '@/components/TabItemInfo.vue'
import TabFileInfo from '@/components/TabFileInfo.vue'
import TabStateInfo from '@/components/TabStateInfo.vue'
import releaseStatusDialog from './releaseStatusDialog.vue'
import { fetchPushFlag } from '@/resource/api/index'
export default {
  name: 'ProgramDetail',
  props: {
    dialogData: {
      type: Object,
      default: () => {}
    }
  },
  components: {
    Video,
    ItemInfo,
    TabFileInfo,
    TabStateInfo,
    releaseStatusDialog
  },

  data () {
    return {
      currentTabComponent: 'ItemInfo',
      form: {
        state: '未通过',
        always: ''
      },
      releaseStatusData: [],
      isProgram: 'program'
    }
  },
  methods: {
    // 去编辑节目页
    goEdit (row) {
      const auditState = row.auditState
      if (auditState == 'AUDIT_ING' || auditState == 'RE_AUDIT_ING' || auditState == 'RE_AUDIT_PASS') {
        this.$alert('内容审核中，不可编辑', '提示', {
          confirmButtonText: '确定',
          callback: action => {}
        })
      } else {
        this.$router.push({
          path: '/newGroup',
          query: {
            dialogData: JSON.stringify({
              title: '编辑编目',
              programId: row.id
            })
          }
        })
      }
    },
    goRelease () {
      this.$nextTick(() => {
        this.$refs.releaseStatusDataDialog.open()
        const that = this
        const data = {
          id: this.dialogData.data.id,
          companyId: this.$store.state.router.companyId
        }
        // console.log(this.dialogData.data)
        fetchPushFlag(data).then((res) => {
          if (res.code == '1') {
            that.releaseStatusData = res.results
          }
        })
      })
    },
    refresh () {
      this.$emit('refresh')
    },
    closeHandle () {
      this.$emit('closeHandle')
    }
  }
}
</script>
<style lang="less">
  .card-info-box {
    width: 450px;
    position: fixed;
    right: 20px;
    top: 240px;
    height: 70%;
    z-index: 307;
    .el-card {
      height: 100%;
      display: flex;
    }
    .el-card__body {
      width: 100%;
    }
    .tab-content {
      position: relative;
      padding: 10px 0;
      height: 65%;
    }
    .edit-btn {
      position: absolute;
      right: 10px;
      top: 13px;
      z-index: 308;
    }
    .el-tabs__nav-wrap {
      padding: 0 10px;
    }
    .main {
      padding: 0 10px;
      height: 310px;
      overflow-y: auto;
    }
    .close {
      cursor: pointer;
    }
  }
</style>
